module.exports = __webpack_public_path__ + "static/img/公司2.e5f39d0c.png";